import { createEntityAdapter } from '@reduxjs/toolkit'
import { CheckDetails } from '@ancon/wildcat-types'

export const checkDetailsEntityAdapter = createEntityAdapter<CheckDetails>()
